<template>
  <div class="wrap">
    <van-nav-bar fixed placeholder title left-arrow left-text="返回" @click-left="onClickLeft">
      <!-- <template #title>{{ title }}</template> -->
      <div @click="goCase">aaaa</div>
      <template #right>
        <div @click="onClickRight">
          <van-icon class="iconfont m-r-5" class-prefix="icon" name="chaxun"/>
          <span> 重新查询</span>
        </div>
      </template>
    </van-nav-bar>
    <iframe v-show="isPDF" :src="pSrc" width="100%" height="100%" style="background: #5e5e5e;"></iframe>
    <van-image v-show="!isPDF" width="100%" :src="pSrc"/>
    <div class="alert" v-show="errorMessage">
      <div class="title">提示</div>
      <div>{{ errorMessage }}</div>
      <button class="close" @click="onClickLeft">关闭</button>
    </div>
  </div>
</template>

<script>
import {
  NavBar,
  Tabbar,
  TabbarItem,
  Icon,
  Image as VanImage,
  Popup,
  Cell,
  Dialog,
} from "vant";
import {Is_Expire_Tips, Check_File_Url} from "@/api/index";

export default {
  name: "pdf",
  components: {
    [NavBar.name]: NavBar,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Icon.name]: Icon,
    [VanImage.name]: VanImage,
    [Popup.name]: Popup,
    [Cell.name]: Cell,
    [Dialog.name]: Dialog,
  },
  data() {
    return {
      pSrc: "",
      title: "",
      active: "che",
      isPDF: true,
      fileNode: {},
      errorMessage: ''
    };
  },
  methods: {
    goCase() {
      this.$router.push({
        path: "/repair/caselist",
        query: {brandId: this.fileNode.brandId},
      });
    },
    tabChang() {
    },
    onClickLeft() {
      this.$router.back();
    },
    onClickRight() {
      this.$router.go(-3);
    },
  },
  async mounted() {
    let fileNode = sessionStorage.getItem("fileNode");
    if (!fileNode) {
      return;
    }
    let that = this;
    fileNode = JSON.parse(fileNode);

    //到期提醒
    if (sessionStorage.getItem("isTips") != fileNode.brandId) {
      Is_Expire_Tips().then((m) => {
        if (m) {
          Dialog.alert({
            title: "查询期限快到期提示",
            message:
                "尊敬的用户，你的查询期限快要到期，欢迎你再续费，续费请至首页“充值续费”",
          });
          sessionStorage.setItem("isTips", fileNode.brandId);
        }
      });
    }
    this.fileNode = fileNode;
    if (fileNode) {
      this.title = fileNode.name;
      let type = fileNode.type || 'ziliao';
      let filePath = fileNode.url || fileNode.filePath;  //.replace(/\/file\//, "/file/");
      this.isPDF = (filePath.substring(filePath.length - 4) == ".pdf")

      //检查权限，增加阅读记录，返回临时URL
      let pathRet = await Check_File_Url({id: fileNode.id, type: type, url: filePath, brandId: fileNode.brandId});

      if (pathRet.resultType == -1) {
        this.errorMessage = pathRet.message
        return;
      }
      filePath = pathRet.fileUrl

      if (this.isPDF) {
        // this.pSrc =
        //     "./plugin" +
        //     filePath +
        //     "&host=" +
        //     this.global.APIBasePath +
        //     "&type=" + type +
        //     "&brandid=" +
        //     fileNode.brandId +
        //     "&token=" +
        //     localStorage.getItem("AccessToken");
        this.pSrc =
            `/plugin/pdfShow/web/viewer.html?type=${type}&brandid=${fileNode.brandId}&file=${encodeURIComponent(filePath)}&title=${this.title}`;
      } else {
        //this.pSrc = this.global.APIBasePath + filePath + "?brandid=" + fileNode.brandId;
        this.pSrc = filePath;
      }
    }
  },
};
</script>

<style scoped>
.wrap {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  bottom: 0;
}

.van-tabbar {
  height: 35px !important;
}

.wrap .alert {
  background: #FF5555;
  color: white;
  position: absolute;
  top: 100px;
  left: 20px;
  right: 20px;
  padding: 30px 10px;
  font-size: 18px;
  line-height: 30px;
  text-space: 1.5em;
}

.wrap .alert .title {
  font-size: 20px;
  margin-bottom: 20px;
}

.wrap .alert .close {
  margin-top: 50px;
  color: #333;
  font-size: 16px;
  padding: 2px 10px;
}
</style>
